import { useGameStore, EventBus } from '@campus/core';
import { Button, Icon } from '../ds/index.js';

/**
 * DeskPrompt — Bouton contextuel quand le joueur est sur un bureau.
 * Permet de réserver ou libérer le bureau.
 */
export function DeskPrompt() {
  const nearbyDesk = useGameStore((s) => s.nearbyDesk);
  const localDeskId = useGameStore((s) => s.localDeskId);
  const currentZoneId = useGameStore((s) => s.currentZoneId);

  if (!nearbyDesk) return null;

  const zoneSlug = currentZoneId?.split(':')[1] ?? '';
  const isMyDesk = localDeskId === nearbyDesk.deskId;
  const isTaken = !!nearbyDesk.ownerId;

  const handleClick = () => {
    if (isMyDesk) {
      EventBus.emit('ui:desk-release', { deskId: nearbyDesk.deskId, zoneSlug });
    } else if (!isTaken) {
      EventBus.emit('ui:desk-claim', { deskId: nearbyDesk.deskId, zoneSlug });
    }
  };

  const title = isMyDesk ? 'Ton bureau' : nearbyDesk.ownerName ? `Bureau de ${nearbyDesk.ownerName}` : nearbyDesk.label;

  return (
    <div className="pl-float-bottom">
      <div className="pl-pop" role="status" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: (!isTaken || isMyDesk) ? '6px 6px 6px 14px' : '10px 14px', fontSize: 13 }}>
        <Icon name="monitor" size={16} className="pl-menu-icon" />
        <span style={{ flex: 1, fontWeight: 500 }}>{title}</span>
        {(!isTaken || isMyDesk) && (
          <Button variant={isMyDesk ? 'ghost' : 'primary'} size="sm" onClick={handleClick}>
            {isMyDesk ? 'Libérer' : 'Réserver ce bureau'}
          </Button>
        )}
      </div>
    </div>
  );
}
